export class ClientMdmTable {
    public static clientsMdm: any =
        [{
            id: '60869db2f9c91c3530459d19',
            ID_GOLD_ETABLISSEMENT: 1179996,
            CREAT_DT: '2019-09-25 04:13:30',
            LST_UPD_DT: '2021-03-09 01:38:29',
            CREAT_USR_ID: 'ADMINISTRATOR',
            LST_UPD_USR_ID: 'ADMINISTRATOR',
            LST_DEL_DT: '',
            S2P_TRN_DT: '2021-03-09 01:38:29',
            FLD_DELETE: 0,
            RAISON_SOCIALE: 'PHOENIX SERVICES FRANCE',
            SIRET: '40268412000122',
            NOM_COMMERCIAL: 'PHOENcodePostalAdresseIX SERVICES FRANCE',
            PAYS_CLIENT: 'FR',
            language: 'France',
            TVA_INTRACO: 'FR16402684120',
            NAF2008: '3812Z',
            MARCHE: 'ICS',
            SOUS_MARCHE: 'Environnement',
            EFFECTIF: '50',
            NB_MOIS_FERMETURE: '',
            STATUT_JURIDIQUE: 'Etablissement Secondaire',
            STATUT_INSEE: 'Actif',
            DATE_FERMETURE: '',
            STATUT_JUDICIAIRE: '',
            STATUT_GARANTIE_FI: 'DÃ©nommÃ©',
            MONTANT_GARANTIE: '',
            STATUT_CLIENT_ELIS: 'CLIENT',
            ETAGE_BATIMENT: 'SITE ARCELORMITAL',
            NUMERO_VOIE: 'ZONE INDUSTRIELLE',
            MENTION_SPECIALE: '',
            CODE_POSTAL: 13270,
            VILLE: 'FOS SUR MER',
            PAYS_ADRESSE: 'FRANCE',
            LONGITUDE: 4.94456409,
            LATITUDE: 43.43772213,
            ADRESSE: 'ZONE INDUSTRIELLE',
            TELEPHONE: '0442051437',
            FAX: '0442051437',
            TICKET_MOYEN: '',
            CATEGORIE_HEBERGEMENT: '',
            NB_CHAMBRES: '',
            NB_APPARTEMENTS: '',
            NB_PORTEURS: '',
            NB_UTILISATEUR_SANITAIRES: '',
            NB_HABITANTS: '',
            NB_LITS: '',
            DUREE_MOY_SEJOUR: '',
            CODE_AVCLOCATE: 'P20-I44-P3-089',
            WINDOW_KEY: 40268412000122,
            DATE_CREATION_CLIENT: '11/02/2021',
            DATE_FIN_GARANTIE: '',
            SIRET_MATCHCODE: '40268412000122-13410039-ZONE INDUSTRIELLE',
            SURVIVORSHIP_DETAILS: '',
            sign: '',
            ZONE: 1,
            TOURNEE: '',
            ADRESSE_SOURCE: 'ZONE INDUSTRIELLE 13270 FOS SUR MER',
            COUVERTS_JOUR: '',
            ID_SIRETISATION: 'FR40268412000122',
            IMMATRICULATION_FINESS: '',
            IDENTIFIANT_CHD: '',
            CLASSEMENT_HEBERGEMENT: '',
            DEVISE_TICKET_MOYEN: '',
            TAUX_OCCUPATION_RESTAURANT: '',
            TAUX_OCCUPATION_HEBERGEMENT: '',
            __v: 0
        }, {
            id: '60869db2f9c91c3530459d1a',
            ID_GOLD_ETABLISSEMENT: 1136245,
            CREAT_DT: '2019-06-26 01:46:48',
            LST_UPD_DT: '2020-10-17 19:49:56',
            CREAT_USR_ID: 'ADMINISTRATOR',
            LST_UPD_USR_ID: 'ADMINISTRATOR',
            LST_DEL_DT: '',
            S2P_TRN_DT: '2020-10-17 19:49:56',
            FLD_DELETE: 0,
            RAISON_SOCIALE: 'GROUPE OMNIUM DEVELOPPEMENT',
            SIRET: '81961767100022',
            NOM_COMMERCIAL: 'GROUPE OMNIUM DEVELOPPEMENT',
            PAYS_CLIENT: 'FR',
            language: 'France',
            TVA_INTRACO: 'FR25819617671',
            NAF2008: '6630Z',
            MARCHE: 'ICS',
            SOUS_MARCHE: 'Banque et assurance',
            EFFECTIF: '16',
            NB_MOIS_FERMETURE: '',
            STATUT_JURIDIQUE: 'SociÃ©tÃ© par actions simplifiÃ©e Ã  associÃ© unique (SASU)',
            STATUT_INSEE: 'Actif',
            DATE_FERMETURE: '',
            STATUT_JUDICIAIRE: '',
            STATUT_GARANTIE_FI: 'Non dÃ©nommÃ©',
            MONTANT_GARANTIE: '',
            STATUT_CLIENT_ELIS: 'CLIENT',
            ETAGE_BATIMENT: 'ZAC LA VALENTINE',
            NUMERO_VOIE: '117 TRAVERSE DE LA MONTRE',
            MENTION_SPECIALE: '',
            CODE_POSTAL: 13011,
            VILLE: 'MARSEILLE',
            PAYS_ADRESSE: 'FRANCE',
            LONGITUDE: 5.47585843,
            LATITUDE: 43.29503729,
            ADRESSE: '117 TRAVERSE DE LA MONTRE',
            TELEPHONE: '0491879205',
            FAX: '0491879209',
            TICKET_MOYEN: '',
            CATEGORIE_HEBERGEMENT: '',
            NB_CHAMBRES: '',
            NB_APPARTEMENTS: '',
            NB_PORTEURS: '',
            NB_UTILISATEUR_SANITAIRES: '',
            NB_HABITANTS: '',
            NB_LITS: '',
            DUREE_MOY_SEJOUR: '',
            CODE_AVCLOCATE: 'V44-I44-P6-100',
            WINDOW_KEY: 81961767100022,
            DATE_CREATION_CLIENT: '02/01/2012',
            DATE_FIN_GARANTIE: '',
            SIRET_MATCHCODE: '81961767100022-13398211-117 TRAVERSE DE LA MONTRE',
            SURVIVORSHIP_DETAILS: '',
            sign: '',
            ZONE: 4,
            TOURNEE: '',
            ADRESSE_SOURCE: '117 TRAVERSE DE LA MONTRE 13011 MARSEILLE',
            COUVERTS_JOUR: '',
            ID_SIRETISATION: 'FR819617671',
            IMMATRICULATION_FINESS: '',
            IDENTIFIANT_CHD: '',
            CLASSEMENT_HEBERGEMENT: '',
            DEVISE_TICKET_MOYEN: '',
            TAUX_OCCUPATION_RESTAURANT: '',
            TAUX_OCCUPATION_HEBERGEMENT: '',
            __v: 0
        }, {
            id: '60869db2f9c91c3530459d1b',
            ID_GOLD_ETABLISSEMENT: 276569,
            CREAT_DT: '2018-02-16 07:30:53',
            LST_UPD_DT: '2021-04-03 18:59:46',
            CREAT_USR_ID: 'SYSTEM',
            LST_UPD_USR_ID: 'ADMINISTRATOR',
            LST_DEL_DT: '',
            S2P_TRN_DT: '2021-04-03 18:59:46',
            FLD_DELETE: 0,
            RAISON_SOCIALE: 'ATELIERS DE FOS',
            SIRET: '33335172400088',
            NOM_COMMERCIAL: 'ATELIERS DE FOS',
            PAYS_CLIENT: 'FR',
            language: 'France',
            TVA_INTRACO: 'FR25333351724',
            NAF2008: '3311Z',
            MARCHE: 'ICS',
            SOUS_MARCHE: 'Industrie manufacturiÃ¨re',
            EFFECTIF: '20',
            NB_MOIS_FERMETURE: '',
            STATUT_JURIDIQUE: 'SociÃ©tÃ© par actions simplifiÃ©e (SAS)',
            STATUT_INSEE: 'Actif',
            DATE_FERMETURE: '',
            STATUT_JUDICIAIRE: '',
            STATUT_GARANTIE_FI: 'Non dÃ©nommÃ©',
            MONTANT_GARANTIE: '',
            STATUT_CLIENT_ELIS: 'CLIENT',
            ETAGE_BATIMENT: 'BATIMENT G',
            NUMERO_VOIE: 'ZI LA BASTIDE BLANCHE',
            MENTION_SPECIALE: 'BP 80221',
            CODE_POSTAL: 13127,
            VILLE: 'VITROLLES',
            PAYS_ADRESSE: 'FRANCE',
            LONGITUDE: 5.26403842,
            LATITUDE: 43.43043254,
            ADRESSE: 'ZI LA BASTIDE BLANCHE BP 80221',
            TELEPHONE: '0442774850',
            FAX: '0442779602',
            TICKET_MOYEN: '0',
            CATEGORIE_HEBERGEMENT: '',
            NB_CHAMBRES: '1',
            NB_APPARTEMENTS: '1',
            NB_PORTEURS: '',
            NB_UTILISATEUR_SANITAIRES: '',
            NB_HABITANTS: '',
            NB_LITS: '',
            DUREE_MOY_SEJOUR: '',
            CODE_AVCLOCATE: 'V42-I44-P6-096',
            WINDOW_KEY: 33335172400088,
            DATE_CREATION_CLIENT: '29/03/2021',
            DATE_FIN_GARANTIE: '',
            SIRET_MATCHCODE: '33335172400088-13429117-ZI LA BASTIDE BLANCHE',
            SURVIVORSHIP_DETAILS: '',
            sign: '',
            ZONE: 1,
            TOURNEE: '',
            ADRESSE_SOURCE: 'BASTIDE BLANCHE 13127 VITROLLES',
            COUVERTS_JOUR: '',
            ID_SIRETISATION: 'FR333351724',
            IMMATRICULATION_FINESS: '',
            IDENTIFIANT_CHD: '',
            CLASSEMENT_HEBERGEMENT: '',
            DEVISE_TICKET_MOYEN: 'EUR',
            TAUX_OCCUPATION_RESTAURANT: '',
            TAUX_OCCUPATION_HEBERGEMENT: '',
            __v: 0
        }, {
            id: '60869db2f9c91c3530459d1c',
            ID_GOLD_ETABLISSEMENT: 93424,
            CREAT_DT: '2016-12-01 02:49:03',
            LST_UPD_DT: '2020-10-16 00:00:11',
            CREAT_USR_ID: 'SYSTEM',
            LST_UPD_USR_ID: 'ADMINISTRATOR',
            LST_DEL_DT: '',
            S2P_TRN_DT: '2020-10-16 00:00:11',
            FLD_DELETE: 0,
            RAISON_SOCIALE: 'A.B.C. INDUSTRIE',
            SIRET: '34119736600030',
            NOM_COMMERCIAL: 'A.B.C. INDUSTRIE',
            PAYS_CLIENT: 'FR',
            language: 'France',
            TVA_INTRACO: 'FR95341197366',
            NAF2008: '1013A',
            MARCHE: 'ICS',
            SOUS_MARCHE: 'Industrie agro-alimentaire',
            EFFECTIF: '176',
            NB_MOIS_FERMETURE: '',
            STATUT_JURIDIQUE: 'SociÃ©tÃ© par actions simplifiÃ©e (SAS)',
            STATUT_INSEE: 'Actif',
            DATE_FERMETURE: '',
            STATUT_JUDICIAIRE: '',
            STATUT_GARANTIE_FI: 'DÃ©nommÃ©',
            MONTANT_GARANTIE: '',
            STATUT_CLIENT_ELIS: 'CLIENT',
            ETAGE_BATIMENT: '',
            NUMERO_VOIE: '165 ROUTE DU PLAN',
            MENTION_SPECIALE: '',
            CODE_POSTAL: 13860,
            VILLE: 'PEYROLLES EN PROVENCE',
            PAYS_ADRESSE: 'FRANCE',
            LONGITUDE: 5.57768368,
            LATITUDE: 43.64426933,
            ADRESSE: '165 ROUTE DU PLAN',
            TELEPHONE: '0442577700',
            FAX: '0442578929',
            TICKET_MOYEN: '',
            CATEGORIE_HEBERGEMENT: '',
            NB_CHAMBRES: '',
            NB_APPARTEMENTS: '',
            NB_PORTEURS: '',
            NB_UTILISATEUR_SANITAIRES: '',
            NB_HABITANTS: '',
            NB_LITS: '',
            DUREE_MOY_SEJOUR: '',
            CODE_AVCLOCATE: 'V44-I44-P6-099',
            WINDOW_KEY: 34119736600030,
            DATE_CREATION_CLIENT: '13/06/2011',
            DATE_FIN_GARANTIE: '',
            SIRET_MATCHCODE: '34119736600030-13128074-165 ROUTE DU PLAN',
            SURVIVORSHIP_DETAILS: '',
            sign: '',
            ZONE: 6,
            TOURNEE: '',
            ADRESSE_SOURCE: '7 ROUTE DU PLAN 13860 PEYROLLES EN PROVENCE',
            COUVERTS_JOUR: '',
            ID_SIRETISATION: 'FR341197366',
            IMMATRICULATION_FINESS: '',
            IDENTIFIANT_CHD: '',
            CLASSEMENT_HEBERGEMENT: '',
            DEVISE_TICKET_MOYEN: '',
            TAUX_OCCUPATION_RESTAURANT: '',
            TAUX_OCCUPATION_HEBERGEMENT: '',
            __v: 0
        }, {
            id: '60869db2f9c91c3530459d1d',
            ID_GOLD_ETABLISSEMENT: 2746,
            CREAT_DT: '2016-04-27 15:14:05',
            LST_UPD_DT: '2020-10-16 13:36:29',
            CREAT_USR_ID: 'SYSTEM',
            LST_UPD_USR_ID: 'ADMINISTRATOR',
            LST_DEL_DT: '',
            S2P_TRN_DT: '2020-10-16 13:36:29',
            FLD_DELETE: 0,
            RAISON_SOCIALE: 'SOCIETE HOTEL NEGRE COSTE',
            SIRET: '58162109100015',
            NOM_COMMERCIAL: 'SOCIETE HOTEL NEGRE COSTE',
            PAYS_CLIENT: 'FR',
            language: 'France',
            TVA_INTRACO: 'FR28581621091',
            NAF2008: '5510Z',
            MARCHE: 'HORE',
            SOUS_MARCHE: 'HÃ´tellerie',
            EFFECTIF: '14',
            NB_MOIS_FERMETURE: '',
            STATUT_JURIDIQUE: 'SociÃ©tÃ© Ã  responsabilitÃ© limitÃ©e Ã  associÃ© unique',
            STATUT_INSEE: 'Actif',
            DATE_FERMETURE: '',
            STATUT_JUDICIAIRE: '',
            STATUT_GARANTIE_FI: 'Non dÃ©nommÃ©',
            MONTANT_GARANTIE: '',
            STATUT_CLIENT_ELIS: 'CLIENT',
            ETAGE_BATIMENT: '',
            NUMERO_VOIE: '33 COURS MIRABEAU',
            MENTION_SPECIALE: '',
            CODE_POSTAL: 13100,
            VILLE: 'AIX EN PROVENCE',
            PAYS_ADRESSE: 'FRANCE',
            LONGITUDE: 5.44875129,
            LATITUDE: 43.52673966,
            ADRESSE: '33 COURS MIRABEAU',
            TELEPHONE: '0442277422',
            FAX: '0442268093',
            TICKET_MOYEN: '61',
            CATEGORIE_HEBERGEMENT: '',
            NB_CHAMBRES: '1',
            NB_APPARTEMENTS: '1',
            NB_PORTEURS: '',
            NB_UTILISATEUR_SANITAIRES: '',
            NB_HABITANTS: '',
            NB_LITS: '',
            DUREE_MOY_SEJOUR: '',
            CODE_AVCLOCATE: 'V44-I44-P6-098',
            WINDOW_KEY: 58162109100015,
            DATE_CREATION_CLIENT: '16/08/2016',
            DATE_FIN_GARANTIE: '',
            SIRET_MATCHCODE: '58162109100015-13197001-33 COURS MIRABEAU',
            SURVIVORSHIP_DETAILS: '',
            sign: '',
            ZONE: 2,
            TOURNEE: '',
            ADRESSE_SOURCE: '33 COURS MIRABEAU 13100 AIX EN PROVENCE',
            COUVERTS_JOUR: '',
            ID_SIRETISATION: 'FR581621091',
            IMMATRICULATION_FINESS: '',
            IDENTIFIANT_CHD: '',
            CLASSEMENT_HEBERGEMENT: '',
            DEVISE_TICKET_MOYEN: 'EUR',
            TAUX_OCCUPATION_RESTAURANT: '',
            TAUX_OCCUPATION_HEBERGEMENT: '',
            __v: 0
        }, {
            id: '60869db2f9c91c3530459d1e',
            ID_GOLD_ETABLISSEMENT: 60973,
            CREAT_DT: '2016-11-07 01:47:10',
            LST_UPD_DT: '2021-01-14 20:32:16',
            CREAT_USR_ID: 'SYSTEM',
            LST_UPD_USR_ID: 'ADMINISTRATOR',
            LST_DEL_DT: '',
            S2P_TRN_DT: '2021-01-14 20:32:16',
            FLD_DELETE: 0,
            RAISON_SOCIALE: 'SOCORAIL',
            SIRET: '34881114200069',
            NOM_COMMERCIAL: 'SOCORAIL',
            PAYS_CLIENT: 'FR',
            language: 'France',
            TVA_INTRACO: 'FR57348811142',
            NAF2008: '5224B',
            MARCHE: 'ICS',
            SOUS_MARCHE: 'Transport, logistique, entreposage',
            EFFECTIF: '100',
            NB_MOIS_FERMETURE: '',
            STATUT_JURIDIQUE: 'Etablissement Secondaire',
            STATUT_INSEE: 'Actif',
            DATE_FERMETURE: '',
            STATUT_JUDICIAIRE: '',
            STATUT_GARANTIE_FI: 'DÃ©nommÃ©',
            MONTANT_GARANTIE: '',
            STATUT_CLIENT_ELIS: 'CLIENT',
            ETAGE_BATIMENT: 'N 568',
            NUMERO_VOIE: 'BATIMENT NO1 AZUR PLUS',
            MENTION_SPECIALE: '',
            CODE_POSTAL: 13220,
            VILLE: 'CHATEAUNEUF LES MARTIGUES',
            PAYS_ADRESSE: 'FRANCE',
            LONGITUDE: 5.16349569,
            LATITUDE: 43.3820709,
            ADRESSE: 'BATIMENT NO1 AZUR PLUS',
            TELEPHONE: '+33442131352',
            FAX: '0442131370',
            TICKET_MOYEN: '0',
            CATEGORIE_HEBERGEMENT: '',
            NB_CHAMBRES: '1',
            NB_APPARTEMENTS: '1',
            NB_PORTEURS: '',
            NB_UTILISATEUR_SANITAIRES: '',
            NB_HABITANTS: '',
            NB_LITS: '',
            DUREE_MOY_SEJOUR: '',
            CODE_AVCLOCATE: 'V20-I55-P2-087',
            WINDOW_KEY: 34881114200069,
            DATE_CREATION_CLIENT: '17/11/2020',
            DATE_FIN_GARANTIE: '',
            SIRET_MATCHCODE: '34881114200069-BATIMENT NO1 AZUR PLUS',
            SURVIVORSHIP_DETAILS: '',
            sign: 'SOCORAIL',
            ZONE: 12,
            TOURNEE: '',
            ADRESSE_SOURCE: 'N 568 BAT NÂ°1 AZUR PLUS 13161 CHATEAUNEUF-LES-MARTIGUES CEDEX',
            COUVERTS_JOUR: '',
            ID_SIRETISATION: 'FR34881114200069',
            IMMATRICULATION_FINESS: '',
            IDENTIFIANT_CHD: '',
            CLASSEMENT_HEBERGEMENT: '',
            DEVISE_TICKET_MOYEN: 'EUR',
            TAUX_OCCUPATION_RESTAURANT: '',
            TAUX_OCCUPATION_HEBERGEMENT: '',
            __v: 0
        }, {
            id: '60869db2f9c91c3530459d1f',
            ID_GOLD_ETABLISSEMENT: 1445518,
            CREAT_DT: '2021-03-10 01:12:05',
            LST_UPD_DT: '2021-04-03 21:39:43',
            CREAT_USR_ID: 'ADMINISTRATOR',
            LST_UPD_USR_ID: 'ADMINISTRATOR',
            LST_DEL_DT: '',
            S2P_TRN_DT: '2021-04-03 21:39:43',
            FLD_DELETE: 0,
            RAISON_SOCIALE: 'ASSOCIATION MARSEILLAISE DE SANTE POUR TOUS',
            SIRET: '89322654800012',
            NOM_COMMERCIAL: 'ASSOCIATION MARSEILLAISE DE SANTE POUR TOUS',
            PAYS_CLIENT: 'FR',
            language: 'France',
            TVA_INTRACO: 'FR45893226548',
            NAF2008: '8621Z',
            MARCHE: 'SANTE',
            SOUS_MARCHE: 'SantÃ© libÃ©rale',
            EFFECTIF: 'n.d.',
            NB_MOIS_FERMETURE: '',
            STATUT_JURIDIQUE: 'Association',
            STATUT_INSEE: 'Actif',
            DATE_FERMETURE: '',
            STATUT_JUDICIAIRE: '',
            STATUT_GARANTIE_FI: 'En cours',
            MONTANT_GARANTIE: '',
            STATUT_CLIENT_ELIS: 'CLIENT',
            ETAGE_BATIMENT: '',
            NUMERO_VOIE: '82 RUE STANISLAS TORRENTS',
            MENTION_SPECIALE: '',
            CODE_POSTAL: 13006,
            VILLE: 'MARSEILLE',
            PAYS_ADRESSE: 'FRANCE',
            LONGITUDE: 5.37945449,
            LATITUDE: 43.28576687,
            ADRESSE: '82 RUE STANISLAS TORRENTS',
            TELEPHONE: '0603312138',
            FAX: '',
            TICKET_MOYEN: '',
            CATEGORIE_HEBERGEMENT: '',
            NB_CHAMBRES: '1',
            NB_APPARTEMENTS: '1',
            NB_PORTEURS: '',
            NB_UTILISATEUR_SANITAIRES: '',
            NB_HABITANTS: '',
            NB_LITS: '',
            DUREE_MOY_SEJOUR: '',
            CODE_AVCLOCATE: 'V44-I44-P6-100',
            WINDOW_KEY: 89322654800012,
            DATE_CREATION_CLIENT: '25/05/2021',
            DATE_FIN_GARANTIE: '',
            SIRET_MATCHCODE: '89322654800012-13398206-82 RUE STANISLAS TORRENTS',
            SURVIVORSHIP_DETAILS: '',
            sign: '',
            ZONE: 4,
            TOURNEE: '',
            ADRESSE_SOURCE: '82 RUE STANISLAS TORRENTS 13006 MARSEILLE',
            COUVERTS_JOUR: '',
            ID_SIRETISATION: 'FR893226548',
            IMMATRICULATION_FINESS: '',
            IDENTIFIANT_CHD: '',
            CLASSEMENT_HEBERGEMENT: '',
            DEVISE_TICKET_MOYEN: '',
            TAUX_OCCUPATION_RESTAURANT: '',
            TAUX_OCCUPATION_HEBERGEMENT: '',
            __v: 0
        }, {
            id: '60869db2f9c91c3530459d20',
            ID_GOLD_ETABLISSEMENT: 1397540,
            CREAT_DT: '2020-10-17 20:41:27',
            LST_UPD_DT: '2021-03-22 19:28:17',
            CREAT_USR_ID: 'ADMINISTRATOR',
            LST_UPD_USR_ID: 'ADMINISTRATOR',
            LST_DEL_DT: '',
            S2P_TRN_DT: '2021-03-22 19:28:17',
            FLD_DELETE: 0,
            RAISON_SOCIALE: 'MAINTEL SUD-EST',
            SIRET: '53791557100039',
            NOM_COMMERCIAL: 'AXIANS MAINTENANCE INFRAS MEDITERRANEE A',
            PAYS_CLIENT: 'FR',
            language: 'FranÃ§ais',
            TVA_INTRACO: 'FR17537915571',
            NAF2008: '4321A',
            MARCHE: '',
            SOUS_MARCHE: '',
            EFFECTIF: '20',
            NB_MOIS_FERMETURE: '',
            STATUT_JURIDIQUE: 'Etablissement Secondaire',
            STATUT_INSEE: 'Actif',
            DATE_FERMETURE: '',
            STATUT_JUDICIAIRE: '',
            STATUT_GARANTIE_FI: '',
            MONTANT_GARANTIE: '',
            STATUT_CLIENT_ELIS: 'PROSPECT',
            ETAGE_BATIMENT: 'ZONE INDUSTRIELLE LES PALUDS',
            NUMERO_VOIE: '160 RUE DE LA MAIRE',
            MENTION_SPECIALE: '',
            CODE_POSTAL: 13400,
            VILLE: 'AUBAGNE',
            PAYS_ADRESSE: 'FRANCE',
            LONGITUDE: null,
            LATITUDE: null,
            ADRESSE: '160 RUE DE LA MAIRE',
            TELEPHONE: '+33442739938',
            FAX: '',
            TICKET_MOYEN: '',
            CATEGORIE_HEBERGEMENT: '',
            NB_CHAMBRES: '1',
            NB_APPARTEMENTS: '1',
            NB_PORTEURS: '',
            NB_UTILISATEUR_SANITAIRES: '',
            NB_HABITANTS: '',
            NB_LITS: '',
            DUREE_MOY_SEJOUR: '',
            CODE_AVCLOCATE: 'V22-I44-P6-100',
            WINDOW_KEY: 53791557100039,
            DATE_CREATION_CLIENT: '',
            DATE_FIN_GARANTIE: '',
            SIRET_MATCHCODE: '53791557100039-160 RUE DE LA MAIRE',
            SURVIVORSHIP_DETAILS: '',
            sign: 'AXIANS MAINTENANCE INFRAS MEDITERRANEE',
            ZONE: null,
            TOURNEE: '',
            ADRESSE_SOURCE: '',
            COUVERTS_JOUR: '',
            ID_SIRETISATION: 'FR53791557100039',
            IMMATRICULATION_FINESS: '',
            IDENTIFIANT_CHD: '',
            CLASSEMENT_HEBERGEMENT: '',
            DEVISE_TICKET_MOYEN: '',
            TAUX_OCCUPATION_RESTAURANT: '',
            TAUX_OCCUPATION_HEBERGEMENT: '',
            __v: 0
        }, {
            id: '60869db2f9c91c3530459d21',
            ID_GOLD_ETABLISSEMENT: 925,
            CREAT_DT: '2016-04-27 13:01:23',
            LST_UPD_DT: '2021-04-07 01:14:06',
            CREAT_USR_ID: 'SYSTEM',
            LST_UPD_USR_ID: 'ADMINISTRATOR',
            LST_DEL_DT: '',
            S2P_TRN_DT: '2021-04-07 01:14:06',
            FLD_DELETE: 0,
            RAISON_SOCIALE: 'SCANIA FRANCE',
            SIRET: '30716693400033',
            NOM_COMMERCIAL: 'SCANIA FRANCE',
            PAYS_CLIENT: 'FR',
            language: 'France',
            TVA_INTRACO: 'FR38307166934',
            NAF2008: '4519Z',
            MARCHE: 'ICS',
            SOUS_MARCHE: 'RÃ©seaux automobile',
            EFFECTIF: '100',
            NB_MOIS_FERMETURE: '',
            STATUT_JURIDIQUE: 'SociÃ©tÃ© par actions simplifiÃ©e (SAS)',
            STATUT_INSEE: 'Actif',
            DATE_FERMETURE: '',
            STATUT_JUDICIAIRE: '',
            STATUT_GARANTIE_FI: 'DÃ©nommÃ©',
            MONTANT_GARANTIE: '',
            STATUT_CLIENT_ELIS: 'CLIENT',
            ETAGE_BATIMENT: 'ZONE INDUSTRIELLE D ECOUFLANT',
            NUMERO_VOIE: '2 BOULEVARD DE L INDUSTRIE',
            MENTION_SPECIALE: '',
            CODE_POSTAL: 49100,
            VILLE: 'ANGERS',
            PAYS_ADRESSE: 'FRANCE',
            LONGITUDE: -0.52212865,
            LATITUDE: 47.49204214,
            ADRESSE: '2 BOULEVARD DE L INDUSTRIE',
            TELEPHONE: '0241413333',
            FAX: '0241347625',
            TICKET_MOYEN: '0',
            CATEGORIE_HEBERGEMENT: '',
            NB_CHAMBRES: '1',
            NB_APPARTEMENTS: '1',
            NB_PORTEURS: '',
            NB_UTILISATEUR_SANITAIRES: '',
            NB_HABITANTS: '',
            NB_LITS: '',
            DUREE_MOY_SEJOUR: '',
            CODE_AVCLOCATE: 'V32-I55-P6-098',
            WINDOW_KEY: 30716693400033,
            DATE_CREATION_CLIENT: '28/04/2010',
            DATE_FIN_GARANTIE: '',
            SIRET_MATCHCODE: '30716693400033-49198007-2 BOULEVARD DE L INDUSTRIE',
            SURVIVORSHIP_DETAILS: '',
            sign: 'SCANIA',
            ZONE: 2,
            TOURNEE: '',
            ADRESSE_SOURCE: 'CS 30106 2 BOULEVARD DE LINDUSTRIE 49100 ANGERS CEDEX 01',
            COUVERTS_JOUR: '',
            ID_SIRETISATION: 'FR307166934',
            IMMATRICULATION_FINESS: '',
            IDENTIFIANT_CHD: '',
            CLASSEMENT_HEBERGEMENT: '',
            DEVISE_TICKET_MOYEN: 'EUR',
            TAUX_OCCUPATION_RESTAURANT: '',
            TAUX_OCCUPATION_HEBERGEMENT: '',
            __v: 0
        }, {
            id: '60869db2f9c91c3530459d22',
            ID_GOLD_ETABLISSEMENT: 93872,
            CREAT_DT: '2016-12-01 03:02:43',
            LST_UPD_DT: '2021-04-03 03:36:08',
            CREAT_USR_ID: 'SYSTEM',
            LST_UPD_USR_ID: 'ADMINISTRATOR',
            LST_DEL_DT: '',
            S2P_TRN_DT: '2021-04-03 03:36:08',
            FLD_DELETE: 0,
            RAISON_SOCIALE: 'LISANYDIS',
            SIRET: '38350830600016',
            NOM_COMMERCIAL: 'LISANYDIS',
            PAYS_CLIENT: 'FR',
            language: 'France',
            TVA_INTRACO: 'FR73383508306',
            NAF2008: '4711D',
            MARCHE: 'ICS',
            SOUS_MARCHE: 'GMS (Grande et Moyenne Surface)',
            EFFECTIF: '90',
            NB_MOIS_FERMETURE: '',
            STATUT_JURIDIQUE: 'SociÃ©tÃ© par actions simplifiÃ©e (SAS)',
            STATUT_INSEE: 'Actif',
            DATE_FERMETURE: '',
            STATUT_JUDICIAIRE: '',
            STATUT_GARANTIE_FI: 'Non dÃ©nommÃ©',
            MONTANT_GARANTIE: '',
            STATUT_CLIENT_ELIS: 'CLIENT',
            ETAGE_BATIMENT: '',
            NUMERO_VOIE: 'QUARTIER LA VALETTE',
            MENTION_SPECIALE: '',
            CODE_POSTAL: 84160,
            VILLE: 'PUYVERT',
            PAYS_ADRESSE: 'FRANCE',
            LONGITUDE: 5.33642087,
            LATITUDE: 43.74988848,
            ADRESSE: 'QUARTIER LA VALETTE',
            TELEPHONE: '0490084073',
            FAX: '0490083688',
            TICKET_MOYEN: '',
            CATEGORIE_HEBERGEMENT: '',
            NB_CHAMBRES: '',
            NB_APPARTEMENTS: '',
            NB_PORTEURS: '',
            NB_UTILISATEUR_SANITAIRES: '',
            NB_HABITANTS: '',
            NB_LITS: '',
            DUREE_MOY_SEJOUR: '',
            CODE_AVCLOCATE: '',
            WINDOW_KEY: 38350830600016,
            DATE_CREATION_CLIENT: '24/03/2021',
            DATE_FIN_GARANTIE: '',
            SIRET_MATCHCODE: '38350830600016-84108095-QUARTIER LA VALETTE',
            SURVIVORSHIP_DETAILS: '',
            sign: 'SYSTEME U',
            ZONE: 4,
            TOURNEE: '',
            ADRESSE_SOURCE: 'RTE NATIONALE 913 CENTRE COMMERCIAL LA VALET 84160 PUYVERT',
            COUVERTS_JOUR: '',
            ID_SIRETISATION: 'FR383508306',
            IMMATRICULATION_FINESS: '',
            IDENTIFIANT_CHD: '',
            CLASSEMENT_HEBERGEMENT: '',
            DEVISE_TICKET_MOYEN: '',
            TAUX_OCCUPATION_RESTAURANT: '',
            TAUX_OCCUPATION_HEBERGEMENT: '',
            __v: 0
        }, {
            id: '60869db2f9c91c3530459d23',
            ID_GOLD_ETABLISSEMENT: 275086,
            CREAT_DT: '2018-01-05 23:05:01',
            LST_UPD_DT: '2021-03-26 22:01:00',
            CREAT_USR_ID: 'SYSTEM',
            LST_UPD_USR_ID: 'ADMINISTRATOR',
            LST_DEL_DT: '',
            S2P_TRN_DT: '2021-03-26 22:01:00',
            FLD_DELETE: 0,
            RAISON_SOCIALE: 'OTIM IMMOBILIER',
            SIRET: '32699146000113',
            NOM_COMMERCIAL: 'OTIM IMMOBILIER',
            PAYS_CLIENT: 'FR',
            language: 'FranÃ§ais',
            TVA_INTRACO: 'FR06326991460',
            NAF2008: '6832A',
            MARCHE: 'ICS',
            SOUS_MARCHE: 'Conseil, gestion et administration privÃ©e',
            EFFECTIF: '20',
            NB_MOIS_FERMETURE: '',
            STATUT_JURIDIQUE: 'Etablissement Secondaire',
            STATUT_INSEE: 'Actif',
            DATE_FERMETURE: '',
            STATUT_JUDICIAIRE: '',
            STATUT_GARANTIE_FI: 'Non dÃ©nommÃ©',
            MONTANT_GARANTIE: '',
            STATUT_CLIENT_ELIS: 'CLIENT',
            ETAGE_BATIMENT: '',
            NUMERO_VOIE: '20 AVENUE DE CORINTHE',
            MENTION_SPECIALE: '6E ARRONDISSEMENT 13006',
            CODE_POSTAL: 13006,
            VILLE: 'MARSEILLE',
            PAYS_ADRESSE: 'FRANCE',
            LONGITUDE: 5.39023161,
            LATITUDE: 43.2832901,
            ADRESSE: '20 AVENUE DE CORINTHE 6E ARRONDISSEMENT 13006',
            TELEPHONE: '0491864600',
            FAX: '0491864301',
            TICKET_MOYEN: '',
            CATEGORIE_HEBERGEMENT: '',
            NB_CHAMBRES: '',
            NB_APPARTEMENTS: '',
            NB_PORTEURS: '',
            NB_UTILISATEUR_SANITAIRES: '',
            NB_HABITANTS: '',
            NB_LITS: '',
            DUREE_MOY_SEJOUR: '',
            CODE_AVCLOCATE: 'V44-I44-P6-100',
            WINDOW_KEY: 32699146000113,
            DATE_CREATION_CLIENT: '07/06/2018',
            DATE_FIN_GARANTIE: '',
            SIRET_MATCHCODE: '32699146000113-20 AVENUE DE CORINTHE',
            SURVIVORSHIP_DETAILS: '',
            sign: 'OTIM IMMO 7',
            ZONE: 6,
            TOURNEE: '',
            ADRESSE_SOURCE: '20 AVENUE DE CORINTHE 13006 MARSEILLE',
            COUVERTS_JOUR: '',
            ID_SIRETISATION: 'FR32699146000113',
            IMMATRICULATION_FINESS: '',
            IDENTIFIANT_CHD: '',
            CLASSEMENT_HEBERGEMENT: '',
            DEVISE_TICKET_MOYEN: '',
            TAUX_OCCUPATION_RESTAURANT: '',
            TAUX_OCCUPATION_HEBERGEMENT: '',
            __v: 0
        }, {
            id: '60869db2f9c91c3530459d24',
            ID_GOLD_ETABLISSEMENT: 93670,
            CREAT_DT: '2016-12-01 02:56:21',
            LST_UPD_DT: '2021-04-16 22:37:53',
            CREAT_USR_ID: 'SYSTEM',
            LST_UPD_USR_ID: 'ADMINISTRATOR',
            LST_DEL_DT: '',
            S2P_TRN_DT: '2021-04-16 22:37:53',
            FLD_DELETE: 0,
            RAISON_SOCIALE: 'OM OPERATIONS',
            SIRET: '40188740100040',
            NOM_COMMERCIAL: 'OLYMPIQUE DE MARSEILLE',
            PAYS_CLIENT: 'FR',
            language: 'FranÃ§ais',
            TVA_INTRACO: 'FR36401887401',
            NAF2008: '9312Z',
            MARCHE: 'ICS',
            SOUS_MARCHE: 'Culture, enseignement, loisirs et informations',
            EFFECTIF: '100',
            NB_MOIS_FERMETURE: '',
            STATUT_JURIDIQUE: 'SociÃ©tÃ© anonyme Ã  directoire',
            STATUT_INSEE: 'Actif',
            DATE_FERMETURE: '',
            STATUT_JUDICIAIRE: '',
            STATUT_GARANTIE_FI: 'RefusÃ©',
            MONTANT_GARANTIE: '',
            STATUT_CLIENT_ELIS: 'CLIENT',
            ETAGE_BATIMENT: 'CTRE ENTRAINEMENT ROBERT DREYFUS',
            NUMERO_VOIE: '33 TERRASSE DE LA MARTINE',
            MENTION_SPECIALE: '11E ARRONDISSEMENT 13011',
            CODE_POSTAL: 13011,
            VILLE: 'MARSEILLE',
            PAYS_ADRESSE: 'FRANCE',
            LONGITUDE: 5.4687277,
            LATITUDE: 43.30016049,
            ADRESSE: '33 TERRASSE DE LA MARTINE',
            TELEPHONE: '+33491769124',
            FAX: '0491760777',
            TICKET_MOYEN: '0',
            CATEGORIE_HEBERGEMENT: '',
            NB_CHAMBRES: '1',
            NB_APPARTEMENTS: '1',
            NB_PORTEURS: '',
            NB_UTILISATEUR_SANITAIRES: '',
            NB_HABITANTS: '',
            NB_LITS: '',
            DUREE_MOY_SEJOUR: '',
            CODE_AVCLOCATE: 'P22-I44-P6-090',
            WINDOW_KEY: 40188740100040,
            DATE_CREATION_CLIENT: '01/07/2005',
            DATE_FIN_GARANTIE: '',
            SIRET_MATCHCODE: '40188740100040-33 TERRASSE DE LA MARTINE',
            SURVIVORSHIP_DETAILS: '',
            sign: 'OLYMPIQUE DE MARSEILLE OM-DROIT AU BUT',
            ZONE: 6,
            TOURNEE: '',
            ADRESSE_SOURCE: 'CTRE ENTRAINEMENT ROBERT DREYFUS 33 TERRASSE DE LA MARTINE 13012 MARSEILLE',
            COUVERTS_JOUR: '',
            ID_SIRETISATION: 'FR401887401',
            IMMATRICULATION_FINESS: '',
            IDENTIFIANT_CHD: '',
            CLASSEMENT_HEBERGEMENT: '',
            DEVISE_TICKET_MOYEN: 'EUR',
            TAUX_OCCUPATION_RESTAURANT: '',
            TAUX_OCCUPATION_HEBERGEMENT: '',
            __v: 0
        }, {
            id: '60869db2f9c91c3530459d25',
            ID_GOLD_ETABLISSEMENT: 241128,
            CREAT_DT: '2017-03-07 13:38:19',
            LST_UPD_DT: '2020-10-04 03:56:12',
            CREAT_USR_ID: 'SYSTEM',
            LST_UPD_USR_ID: 'ADMINISTRATOR',
            LST_DEL_DT: '',
            S2P_TRN_DT: '2020-10-04 03:56:12',
            FLD_DELETE: 0,
            RAISON_SOCIALE: 'SOC LOQUESIENNE DE CHARCUTERIE',
            SIRET: '7180603800023',
            NOM_COMMERCIAL: 'SOC LOQUESIENNE DE CHARCUTERIE',
            PAYS_CLIENT: 'FR',
            language: 'France',
            TVA_INTRACO: 'FR41071806038',
            NAF2008: '1013A',
            MARCHE: 'ICS',
            SOUS_MARCHE: 'Industrie agro-alimentaire',
            EFFECTIF: '46',
            NB_MOIS_FERMETURE: '',
            STATUT_JURIDIQUE: 'SociÃ©tÃ© par actions simplifiÃ©e (SAS)',
            STATUT_INSEE: 'Actif',
            DATE_FERMETURE: '',
            STATUT_JUDICIAIRE: '',
            STATUT_GARANTIE_FI: 'RefusÃ©',
            MONTANT_GARANTIE: '',
            STATUT_CLIENT_ELIS: 'CLIENT',
            ETAGE_BATIMENT: 'ZONE INDUSTRIELLE DES ESTROUBLANS',
            NUMERO_VOIE: '38 BOULEVARD DE L EUROPE',
            MENTION_SPECIALE: '',
            CODE_POSTAL: 13127,
            VILLE: 'VITROLLES',
            PAYS_ADRESSE: 'FRANCE',
            LONGITUDE: 5.24990164,
            LATITUDE: 43.4272613,
            ADRESSE: '38 BOULEVARD DE L EUROPE',
            TELEPHONE: '0491959194',
            FAX: '0442449477',
            TICKET_MOYEN: '0',
            CATEGORIE_HEBERGEMENT: '',
            NB_CHAMBRES: '1',
            NB_APPARTEMENTS: '1',
            NB_PORTEURS: '',
            NB_UTILISATEUR_SANITAIRES: '',
            NB_HABITANTS: '',
            NB_LITS: '',
            DUREE_MOY_SEJOUR: '',
            CODE_AVCLOCATE: 'V22-I44-P6-100',
            WINDOW_KEY: 7180603800023,
            DATE_CREATION_CLIENT: '04/09/2001',
            DATE_FIN_GARANTIE: '',
            SIRET_MATCHCODE: '07180603800023-13429117-38 BOULEVARD DE L EUROPE',
            SURVIVORSHIP_DETAILS: '',
            sign: '',
            ZONE: 4,
            TOURNEE: '',
            ADRESSE_SOURCE: 'Z.I LES ESTROUBLANS 38 BD DE L EUROPE 13127 VITROLLES',
            COUVERTS_JOUR: '',
            ID_SIRETISATION: 'FR071806038',
            IMMATRICULATION_FINESS: '',
            IDENTIFIANT_CHD: '',
            CLASSEMENT_HEBERGEMENT: '',
            DEVISE_TICKET_MOYEN: 'EUR',
            TAUX_OCCUPATION_RESTAURANT: '',
            TAUX_OCCUPATION_HEBERGEMENT: '',
            __v: 0
        }, {
            id: '60869db2f9c91c3530459d26',
            ID_GOLD_ETABLISSEMENT: 93929,
            CREAT_DT: '2016-12-01 03:04:33',
            LST_UPD_DT: '2020-10-03 19:05:43',
            CREAT_USR_ID: 'SYSTEM',
            LST_UPD_USR_ID: 'ADMINISTRATOR',
            LST_DEL_DT: '',
            S2P_TRN_DT: '2020-10-03 19:05:43',
            FLD_DELETE: 0,
            RAISON_SOCIALE: 'JURESON',
            SIRET: '40467353500013',
            NOM_COMMERCIAL: 'JURESON',
            PAYS_CLIENT: 'FR',
            language: 'France',
            TVA_INTRACO: 'FR45404673535',
            NAF2008: '4711D',
            MARCHE: 'ICS',
            SOUS_MARCHE: 'GMS (Grande et Moyenne Surface)',
            EFFECTIF: '16',
            NB_MOIS_FERMETURE: '',
            STATUT_JURIDIQUE: 'SociÃ©tÃ© par actions simplifiÃ©e (SAS)',
            STATUT_INSEE: 'Actif',
            DATE_FERMETURE: '',
            STATUT_JUDICIAIRE: '',
            STATUT_GARANTIE_FI: 'Non dÃ©nommÃ©',
            MONTANT_GARANTIE: '',
            STATUT_CLIENT_ELIS: 'CLIENT',
            ETAGE_BATIMENT: '',
            NUMERO_VOIE: 'FONT DE DURANCE SUD',
            MENTION_SPECIALE: '',
            CODE_POSTAL: 4700,
            VILLE: 'ORAISON',
            PAYS_ADRESSE: 'FRANCE',
            LONGITUDE: 5.91842045,
            LATITUDE: 43.91616376,
            ADRESSE: 'FONT DE DURANCE SUD',
            TELEPHONE: '0492798699',
            FAX: '0492798164',
            TICKET_MOYEN: '',
            CATEGORIE_HEBERGEMENT: '',
            NB_CHAMBRES: '',
            NB_APPARTEMENTS: '',
            NB_PORTEURS: '',
            NB_UTILISATEUR_SANITAIRES: '',
            NB_HABITANTS: '',
            NB_LITS: '',
            DUREE_MOY_SEJOUR: '',
            CODE_AVCLOCATE: 'V33-I33-P6-100',
            WINDOW_KEY: 40467353500013,
            DATE_CREATION_CLIENT: '15/10/1996',
            DATE_FIN_GARANTIE: '',
            SIRET_MATCHCODE: '40467353500013-04410143-FONT DE DURANCE SUD',
            SURVIVORSHIP_DETAILS: '',
            sign: 'INTERMARCHE',
            ZONE: 2,
            TOURNEE: '',
            ADRESSE_SOURCE: 'FONT DE DURANCE SUD 04700 ORAISON',
            COUVERTS_JOUR: '',
            ID_SIRETISATION: 'FR404673535',
            IMMATRICULATION_FINESS: '',
            IDENTIFIANT_CHD: '',
            CLASSEMENT_HEBERGEMENT: '',
            DEVISE_TICKET_MOYEN: '',
            TAUX_OCCUPATION_RESTAURANT: '',
            TAUX_OCCUPATION_HEBERGEMENT: '',
            __v: 0
        }, {
            id: '60869db2f9c91c3530459d27',
            ID_GOLD_ETABLISSEMENT: 242151,
            CREAT_DT: '2017-03-14 00:48:40',
            LST_UPD_DT: '2021-01-16 12:18:05',
            CREAT_USR_ID: 'SYSTEM',
            LST_UPD_USR_ID: 'ADMINISTRATOR',
            LST_DEL_DT: '',
            S2P_TRN_DT: '2021-01-16 12:18:05',
            FLD_DELETE: 0,
            RAISON_SOCIALE: 'ROTORK MOTORISATON SAS',
            SIRET: '60204978500028',
            NOM_COMMERCIAL: 'ROTORK MOTORISATON SAS',
            PAYS_CLIENT: 'FR',
            language: 'France',
            TVA_INTRACO: 'FR55602049785',
            NAF2008: '4669A',
            MARCHE: 'ICS',
            SOUS_MARCHE: 'Grossiste',
            EFFECTIF: '20',
            NB_MOIS_FERMETURE: '',
            STATUT_JURIDIQUE: 'SociÃ©tÃ© par actions simplifiÃ©e (SAS)',
            STATUT_INSEE: 'Actif',
            DATE_FERMETURE: '',
            STATUT_JUDICIAIRE: '',
            STATUT_GARANTIE_FI: 'Non dÃ©nommÃ©',
            MONTANT_GARANTIE: '',
            STATUT_CLIENT_ELIS: 'CLIENT',
            ETAGE_BATIMENT: '',
            NUMERO_VOIE: '75 RUE RATEAU',
            MENTION_SPECIALE: 'CS 10006',
            CODE_POSTAL: 93120,
            VILLE: 'LA COURNEUVE',
            PAYS_ADRESSE: 'FRANCE',
            LONGITUDE: 2.40819085,
            LATITUDE: 48.92520058,
            ADRESSE: '75 RUE RATEAU CS 10006',
            TELEPHONE: '0143111550',
            FAX: '0148354254',
            TICKET_MOYEN: '0',
            CATEGORIE_HEBERGEMENT: '',
            NB_CHAMBRES: '1',
            NB_APPARTEMENTS: '1',
            NB_PORTEURS: '',
            NB_UTILISATEUR_SANITAIRES: '',
            NB_HABITANTS: '',
            NB_LITS: '',
            DUREE_MOY_SEJOUR: '',
            CODE_AVCLOCATE: 'V44-I44-P5-095',
            WINDOW_KEY: 60204978500028,
            DATE_CREATION_CLIENT: '30/07/2016',
            DATE_FIN_GARANTIE: '',
            SIRET_MATCHCODE: '60204978500028-93307027-75 RUE RATEAU',
            SURVIVORSHIP_DETAILS: '',
            sign: 'ROTORK',
            ZONE: 20,
            TOURNEE: '',
            ADRESSE_SOURCE: '75 rue Rateau 93126 LA COURNEUVE CEDEX',
            COUVERTS_JOUR: '',
            ID_SIRETISATION: 'FR602049785',
            IMMATRICULATION_FINESS: '',
            IDENTIFIANT_CHD: '',
            CLASSEMENT_HEBERGEMENT: '',
            DEVISE_TICKET_MOYEN: 'EUR',
            TAUX_OCCUPATION_RESTAURANT: '',
            TAUX_OCCUPATION_HEBERGEMENT: '',
            __v: 0
        }, {
            id: '60869db2f9c91c3530459d28',
            ID_GOLD_ETABLISSEMENT: 260061,
            CREAT_DT: '2017-08-02 00:57:59',
            LST_UPD_DT: '2020-10-09 13:03:25',
            CREAT_USR_ID: 'SYSTEM',
            LST_UPD_USR_ID: 'ADMINISTRATOR',
            LST_DEL_DT: '',
            S2P_TRN_DT: '2020-10-09 13:03:25',
            FLD_DELETE: 0,
            RAISON_SOCIALE: 'AXIONE',
            SIRET: '44958654400016',
            NOM_COMMERCIAL: 'AXIONE',
            PAYS_CLIENT: 'FR',
            language: 'France',
            TVA_INTRACO: 'FR58449586544',
            NAF2008: '6190Z',
            MARCHE: 'ICS',
            SOUS_MARCHE: 'Informatique, web et tÃ©lÃ©communications',
            EFFECTIF: '250',
            NB_MOIS_FERMETURE: '',
            STATUT_JURIDIQUE: 'SociÃ©tÃ© par actions simplifiÃ©e (SAS)',
            STATUT_INSEE: 'Actif',
            DATE_FERMETURE: '',
            STATUT_JUDICIAIRE: '',
            STATUT_GARANTIE_FI: 'Non dÃ©nommÃ©',
            MONTANT_GARANTIE: '',
            STATUT_CLIENT_ELIS: 'CLIENT',
            ETAGE_BATIMENT: '',
            NUMERO_VOIE: '130 BOULEVARD CAMELINAT',
            MENTION_SPECIALE: 'CS 90429',
            CODE_POSTAL: 92240,
            VILLE: 'MALAKOFF',
            PAYS_ADRESSE: 'FRANCE',
            LONGITUDE: 2.29778477,
            LATITUDE: 48.8138118,
            ADRESSE: '130 BOULEVARD CAMELINAT',
            TELEPHONE: '0172339300',
            FAX: '0146540478',
            TICKET_MOYEN: '0',
            CATEGORIE_HEBERGEMENT: '',
            NB_CHAMBRES: '1',
            NB_APPARTEMENTS: '1',
            NB_PORTEURS: '',
            NB_UTILISATEUR_SANITAIRES: '',
            NB_HABITANTS: '',
            NB_LITS: '',
            DUREE_MOY_SEJOUR: '',
            CODE_AVCLOCATE: 'V44-I44-P6-100',
            WINDOW_KEY: 44958654400016,
            DATE_CREATION_CLIENT: '21/12/2018',
            DATE_FIN_GARANTIE: '',
            SIRET_MATCHCODE: '44958654400016-92118046-130 BOULEVARD CAMELINAT',
            SURVIVORSHIP_DETAILS: '',
            sign: 'AXIONE',
            ZONE: 21,
            TOURNEE: '',
            ADRESSE_SOURCE: '130 BOULEVARD CAMELINAT 92240 MALAKOFF',
            COUVERTS_JOUR: '',
            ID_SIRETISATION: 'FR449586544',
            IMMATRICULATION_FINESS: '',
            IDENTIFIANT_CHD: '',
            CLASSEMENT_HEBERGEMENT: '',
            DEVISE_TICKET_MOYEN: 'EUR',
            TAUX_OCCUPATION_RESTAURANT: '',
            TAUX_OCCUPATION_HEBERGEMENT: '',
            __v: 0
        }, {
            id: '60869db2f9c91c3530459d29',
            ID_GOLD_ETABLISSEMENT: 989016,
            CREAT_DT: '2018-05-24 18:24:52',
            LST_UPD_DT: '2019-10-23 04:56:38',
            CREAT_USR_ID: 'ADMINISTRATOR',
            LST_UPD_USR_ID: 'ADMINISTRATOR',
            LST_DEL_DT: '',
            S2P_TRN_DT: '2019-10-23 04:56:38',
            FLD_DELETE: 0,
            RAISON_SOCIALE: 'ENGIE HOME SERVICES',
            SIRET: '30134058406258',
            NOM_COMMERCIAL: 'SAVELYS C G S T SAVE',
            PAYS_CLIENT: 'FR',
            language: 'France',
            TVA_INTRACO: 'FR00301340584',
            NAF2008: '4322B',
            MARCHE: 'ICS',
            SOUS_MARCHE: 'BTP',
            EFFECTIF: '100',
            NB_MOIS_FERMETURE: '',
            STATUT_JURIDIQUE: 'SociÃ©tÃ© par actions simplifiÃ©e Ã  associÃ© unique (SASU)',
            STATUT_INSEE: 'Actif',
            DATE_FERMETURE: '',
            STATUT_JUDICIAIRE: '',
            STATUT_GARANTIE_FI: 'DÃ©nommÃ©',
            MONTANT_GARANTIE: '',
            STATUT_CLIENT_ELIS: 'CLIENT',
            ETAGE_BATIMENT: '',
            NUMERO_VOIE: '361 AVENUE DU PRESIDENT WILSON',
            MENTION_SPECIALE: 'LA PLAINE ST DENIS',
            CODE_POSTAL: 93210,
            VILLE: 'ST DENIS',
            PAYS_ADRESSE: 'FRANCE',
            LONGITUDE: 2.35667944,
            LATITUDE: 48.92429816,
            ADRESSE: '361 AVENUE DU PRESIDENT WILSON',
            TELEPHONE: '+33185575500',
            FAX: '0299812768',
            TICKET_MOYEN: '0',
            CATEGORIE_HEBERGEMENT: '',
            NB_CHAMBRES: '1',
            NB_APPARTEMENTS: '1',
            NB_PORTEURS: '',
            NB_UTILISATEUR_SANITAIRES: '',
            NB_HABITANTS: '',
            NB_LITS: '',
            DUREE_MOY_SEJOUR: '',
            CODE_AVCLOCATE: 'V44-I44-P6-094',
            WINDOW_KEY: 30134058406258,
            DATE_CREATION_CLIENT: '20/02/2017',
            DATE_FIN_GARANTIE: '',
            SIRET_MATCHCODE: '30134058406258-361 AVENUE DU PRESIDENT WILSON',
            SURVIVORSHIP_DETAILS: '',
            sign: 'ENGIE HOME SERVICES',
            ZONE: 1,
            TOURNEE: '',
            ADRESSE_SOURCE: '361 AV DU PRESIDENT WILSON 93210 SAINT DENIS',
            COUVERTS_JOUR: '',
            ID_SIRETISATION: 'FR301340584',
            IMMATRICULATION_FINESS: '',
            IDENTIFIANT_CHD: '',
            CLASSEMENT_HEBERGEMENT: '',
            DEVISE_TICKET_MOYEN: 'EUR',
            TAUX_OCCUPATION_RESTAURANT: '',
            TAUX_OCCUPATION_HEBERGEMENT: '',
            __v: 0
        }, {
            id: '60869db2f9c91c3530459d2a',
            ID_GOLD_ETABLISSEMENT: 256876,
            CREAT_DT: '2017-06-30 22:35:22',
            LST_UPD_DT: '2020-10-07 20:48:59',
            CREAT_USR_ID: 'SYSTEM',
            LST_UPD_USR_ID: 'ADMINISTRATOR',
            LST_DEL_DT: '',
            S2P_TRN_DT: '2020-10-07 20:48:59',
            FLD_DELETE: 0,
            RAISON_SOCIALE: 'DEDEVIANDES',
            SIRET: '43224753400022',
            NOM_COMMERCIAL: 'DEDEVIANDES',
            PAYS_CLIENT: 'FR',
            language: 'France',
            TVA_INTRACO: 'FR54432247534',
            NAF2008: '4632A',
            MARCHE: 'ICS',
            SOUS_MARCHE: 'Grossiste',
            EFFECTIF: '21',
            NB_MOIS_FERMETURE: '',
            STATUT_JURIDIQUE: 'SociÃ©tÃ© Ã  responsabilitÃ© limitÃ©e (SARL)',
            STATUT_INSEE: 'Actif',
            DATE_FERMETURE: '',
            STATUT_JUDICIAIRE: '',
            STATUT_GARANTIE_FI: 'Non dÃ©nommÃ©',
            MONTANT_GARANTIE: '',
            STATUT_CLIENT_ELIS: 'CLIENT',
            ETAGE_BATIMENT: 'ZONE INDUSTRIELLE DES ESTROUBLANS',
            NUMERO_VOIE: '38 BOULEVARD DE L EUROPE',
            MENTION_SPECIALE: '',
            CODE_POSTAL: 13127,
            VILLE: 'VITROLLES',
            PAYS_ADRESSE: 'FRANCE',
            LONGITUDE: 5.24990164,
            LATITUDE: 43.4272613,
            ADRESSE: '38 BOULEVARD DE L EUROPE',
            TELEPHONE: '0491080551',
            FAX: '0491645779',
            TICKET_MOYEN: '',
            CATEGORIE_HEBERGEMENT: '',
            NB_CHAMBRES: '',
            NB_APPARTEMENTS: '',
            NB_PORTEURS: '',
            NB_UTILISATEUR_SANITAIRES: '',
            NB_HABITANTS: '',
            NB_LITS: '',
            DUREE_MOY_SEJOUR: '',
            CODE_AVCLOCATE: 'V32-I44-P6-098',
            WINDOW_KEY: 43224753400022,
            DATE_CREATION_CLIENT: '04/09/2001',
            DATE_FIN_GARANTIE: '',
            SIRET_MATCHCODE: '43224753400022-13429117-38 BOULEVARD DE L EUROPE',
            SURVIVORSHIP_DETAILS: '',
            sign: '',
            ZONE: 4,
            TOURNEE: '',
            ADRESSE_SOURCE: 'ZI LES ESTROUBLANS 38 BOULEVARD DE LEUROPE 13127 VITROLLES',
            COUVERTS_JOUR: '',
            ID_SIRETISATION: 'FR432247534',
            IMMATRICULATION_FINESS: '',
            IDENTIFIANT_CHD: '',
            CLASSEMENT_HEBERGEMENT: '',
            DEVISE_TICKET_MOYEN: '',
            TAUX_OCCUPATION_RESTAURANT: '',
            TAUX_OCCUPATION_HEBERGEMENT: '',
            __v: 0
        }, {
            id: '60869db2f9c91c3530459d2b',
            ID_GOLD_ETABLISSEMENT: 1137155,
            CREAT_DT: '2019-06-28 01:31:58',
            LST_UPD_DT: '2020-10-04 14:32:59',
            CREAT_USR_ID: 'ADMINISTRATOR',
            LST_UPD_USR_ID: 'ADMINISTRATOR',
            LST_DEL_DT: '',
            S2P_TRN_DT: '2020-10-04 14:32:59',
            FLD_DELETE: 0,
            RAISON_SOCIALE: 'DHL INTERNATIONAL EXPRESS FRANCE',
            SIRET: '49495677400710',
            NOM_COMMERCIAL: 'DHL INTERNATIONAL EXPRESS FRANCE',
            PAYS_CLIENT: 'FR',
            language: 'France',
            TVA_INTRACO: 'FR57494956774',
            NAF2008: '5229B',
            MARCHE: 'ICS',
            SOUS_MARCHE: 'Transport, logistique, entreposage',
            EFFECTIF: '50',
            NB_MOIS_FERMETURE: '',
            STATUT_JURIDIQUE: 'Etablissement Secondaire',
            STATUT_INSEE: 'Actif',
            DATE_FERMETURE: '',
            STATUT_JUDICIAIRE: '',
            STATUT_GARANTIE_FI: 'Non dÃ©nommÃ©',
            MONTANT_GARANTIE: '',
            STATUT_CLIENT_ELIS: 'CLIENT',
            ETAGE_BATIMENT: '',
            NUMERO_VOIE: '49 BOULEVARD DE L EUROPE',
            MENTION_SPECIALE: 'CS 80212',
            CODE_POSTAL: 13127,
            VILLE: 'VITROLLES',
            PAYS_ADRESSE: 'FRANCE',
            LONGITUDE: 5.24990164,
            LATITUDE: 43.4272613,
            ADRESSE: '49 BOULEVARD DE L EUROPE CS 80212',
            TELEPHONE: '0825100080',
            FAX: '',
            TICKET_MOYEN: '',
            CATEGORIE_HEBERGEMENT: '',
            NB_CHAMBRES: '',
            NB_APPARTEMENTS: '',
            NB_PORTEURS: '',
            NB_UTILISATEUR_SANITAIRES: '',
            NB_HABITANTS: '',
            NB_LITS: '',
            DUREE_MOY_SEJOUR: '',
            CODE_AVCLOCATE: 'V42-I44-P6-099',
            WINDOW_KEY: 49495677400710,
            DATE_CREATION_CLIENT: '12/11/2012',
            DATE_FIN_GARANTIE: '',
            SIRET_MATCHCODE: '49495677400710-13429117-49 BOULEVARD DE L EUROPE',
            SURVIVORSHIP_DETAILS: '',
            sign: '',
            ZONE: 2,
            TOURNEE: '',
            ADRESSE_SOURCE: '49 BD DE L EUROPE 13127 VITROLLES',
            COUVERTS_JOUR: '',
            ID_SIRETISATION: 'FR49495677400710',
            IMMATRICULATION_FINESS: '',
            IDENTIFIANT_CHD: '',
            CLASSEMENT_HEBERGEMENT: '',
            DEVISE_TICKET_MOYEN: '',
            TAUX_OCCUPATION_RESTAURANT: '',
            TAUX_OCCUPATION_HEBERGEMENT: '',
            __v: 0
        }, {
            id: '60869db2f9c91c3530459d2c',
            ID_GOLD_ETABLISSEMENT: 261298,
            CREAT_DT: '2017-08-15 22:34:49',
            LST_UPD_DT: '2021-03-08 01:04:05',
            CREAT_USR_ID: 'SYSTEM',
            LST_UPD_USR_ID: 'ADMINISTRATOR',
            LST_DEL_DT: '',
            S2P_TRN_DT: '2021-03-08 01:04:05',
            FLD_DELETE: 0,
            RAISON_SOCIALE: 'COMMUNE D AIX EN PROVENCE',
            SIRET: '21130001700012',
            NOM_COMMERCIAL: 'COMMUNE D AIX EN PROVENCE',
            PAYS_CLIENT: 'FR',
            language: 'France',
            TVA_INTRACO: 'FR19211300017',
            NAF2008: '8411Z',
            MARCHE: 'ICS',
            SOUS_MARCHE: 'Administration publique',
            EFFECTIF: '2000',
            NB_MOIS_FERMETURE: '',
            STATUT_JURIDIQUE: 'Administration',
            STATUT_INSEE: 'Actif',
            DATE_FERMETURE: '',
            STATUT_JUDICIAIRE: '',
            STATUT_GARANTIE_FI: 'Exclu',
            MONTANT_GARANTIE: '',
            STATUT_CLIENT_ELIS: 'CLIENT',
            ETAGE_BATIMENT: 'MOYENS GENERAUX',
            NUMERO_VOIE: 'PLACE DE L HOTEL DE VILLE',
            MENTION_SPECIALE: 'CS 30715',
            CODE_POSTAL: 13100,
            VILLE: 'AIX EN PROVENCE',
            PAYS_ADRESSE: 'FRANCE',
            LONGITUDE: 5.44774689,
            LATITUDE: 43.52979569,
            ADRESSE: 'PLACE DE L HOTEL DE VILLE CS 30715',
            TELEPHONE: '0442919000',
            FAX: '0442919492',
            TICKET_MOYEN: '',
            CATEGORIE_HEBERGEMENT: '',
            NB_CHAMBRES: '',
            NB_APPARTEMENTS: '',
            NB_PORTEURS: '',
            NB_UTILISATEUR_SANITAIRES: '',
            NB_HABITANTS: '',
            NB_LITS: '',
            DUREE_MOY_SEJOUR: '',
            CODE_AVCLOCATE: 'P20-I55-P0-092',
            WINDOW_KEY: 21130001700012,
            DATE_CREATION_CLIENT: '30/03/2017',
            DATE_FIN_GARANTIE: '',
            SIRET_MATCHCODE: '21130001700012-13197001-PLACE DE L HOTEL DE VILLE',
            SURVIVORSHIP_DETAILS: '',
            sign: 'MAIRIE',
            ZONE: 2,
            TOURNEE: '',
            ADRESSE_SOURCE: 'DIRECTION MOYENS GENERAUX FONTAINE RESEAU CS 30715 13616 AIX EN PROVENCE',
            COUVERTS_JOUR: '',
            ID_SIRETISATION: 'FR211300017',
            IMMATRICULATION_FINESS: '',
            IDENTIFIANT_CHD: '',
            CLASSEMENT_HEBERGEMENT: '',
            DEVISE_TICKET_MOYEN: '',
            TAUX_OCCUPATION_RESTAURANT: '',
            TAUX_OCCUPATION_HEBERGEMENT: '',
            __v: 0
        }, {
            id: '60869db2f9c91c3530459d2d',
            ID_GOLD_ETABLISSEMENT: 784,
            CREAT_DT: '2016-04-27 12:48:46',
            LST_UPD_DT: '2020-10-16 21:06:18',
            CREAT_USR_ID: 'SYSTEM',
            LST_UPD_USR_ID: 'ADMINISTRATOR',
            LST_DEL_DT: '',
            S2P_TRN_DT: '2020-10-16 21:06:18',
            FLD_DELETE: 0,
            RAISON_SOCIALE: 'GRANDS GARAGES DE PROVENCE',
            SIRET: '33001361600017',
            NOM_COMMERCIAL: 'GRANDS GARAGES DE PROVENCE',
            PAYS_CLIENT: 'FR',
            language: 'France',
            TVA_INTRACO: 'FR78330013616',
            NAF2008: '4511Z',
            MARCHE: 'ICS',
            SOUS_MARCHE: 'RÃ©seaux automobile',
            EFFECTIF: '100',
            NB_MOIS_FERMETURE: '',
            STATUT_JURIDIQUE: 'SociÃ©tÃ© en nom collectif (SNC)',
            STATUT_INSEE: 'Actif',
            DATE_FERMETURE: '',
            STATUT_JUDICIAIRE: '',
            STATUT_GARANTIE_FI: 'DÃ©nommÃ©',
            MONTANT_GARANTIE: '',
            STATUT_CLIENT_ELIS: 'CLIENT',
            ETAGE_BATIMENT: 'LA PIOLINE',
            NUMERO_VOIE: '325 RUE GUILLAUME DU VAIR',
            MENTION_SPECIALE: 'CS 20648',
            CODE_POSTAL: 13290,
            VILLE: 'AIX EN PROVENCE',
            PAYS_ADRESSE: 'FRANCE',
            LONGITUDE: 5.40498684,
            LATITUDE: 43.50796847,
            ADRESSE: '325 RUE GUILLAUME DU VAIR CS 20648',
            TELEPHONE: '0442390000',
            FAX: '0442640657',
            TICKET_MOYEN: '0',
            CATEGORIE_HEBERGEMENT: '',
            NB_CHAMBRES: '1',
            NB_APPARTEMENTS: '1',
            NB_PORTEURS: '',
            NB_UTILISATEUR_SANITAIRES: '',
            NB_HABITANTS: '',
            NB_LITS: '',
            DUREE_MOY_SEJOUR: '',
            CODE_AVCLOCATE: 'V44-I44-P6-093',
            WINDOW_KEY: 33001361600017,
            DATE_CREATION_CLIENT: '06/12/1995',
            DATE_FIN_GARANTIE: '',
            SIRET_MATCHCODE: '33001361600017-13197001-325 RUE GUILLAUME DU VAIR',
            SURVIVORSHIP_DETAILS: '',
            sign: 'PEUGEOT',
            ZONE: 8,
            TOURNEE: '',
            ADRESSE_SOURCE: '325 Rue Guillaume du Vair LA PIOLINE 13546 AIX CEDEX 4',
            COUVERTS_JOUR: '',
            ID_SIRETISATION: 'FR330013616',
            IMMATRICULATION_FINESS: '',
            IDENTIFIANT_CHD: '',
            CLASSEMENT_HEBERGEMENT: '',
            DEVISE_TICKET_MOYEN: 'EUR',
            TAUX_OCCUPATION_RESTAURANT: '',
            TAUX_OCCUPATION_HEBERGEMENT: '',
            __v: 0
        }];
}
